import { ReactWrapperComponent, WrapperProps, GcvEnterBankTheme } from '@user-interface/react-ui';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'gcv-enter-bank-theme',
  template: '<app-react-wrapper [wrappedComponent]="component" ></app-react-wrapper>',
})
export class GcvEnterBankThemeComponent extends ReactWrapperComponent {
  component = GcvEnterBankTheme;

  constructor() {
    super();
  }
}
